/** Copying deposit identifiers, wallet addresses and reference numbers. */
export interface ClipboardApi {
  write(text: string): Promise<boolean>
}

export const webClipboard: ClipboardApi = {
  async write(text) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      return false
    }
  },
}
